module.exports = __webpack_public_path__ + "img/img-arrow.9235979e.gif";